import React, { useState, useEffect } from "react";
import { useForm, Controller } from "react-hook-form";
import { useLocation, useNavigate } from "react-router-dom";
import Select from "react-select";
import Topbar from "../../../Component/Topbar/Topbar";

const TechnicalMove = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const formType = location.state?.type; // "add" | "edit" | "view"
  const existingData = location.state?.data; // Prefill for edit/view
  const isViewMode = formType === "view";
  const isEditMode = formType === "edit";
      const [popup, setPopup] = useState(false);
  

  const {
    control,
    handleSubmit,
    setValue,
    watch,
    formState: { errors },
  } = useForm({
    defaultValues: {
      regionname: "",
      location: "",
    },
  });

  const dummyData = {
    regionname: { value: "south", label: "South Region" },
    location: { value: "chennai", label: "Chennai" },
  };

  const regionOptions = [
    { value: "it_team", label: "IT Support Team" },
    { value: "network_team", label: "Network Operations Team" },
    { value: "hardware_team", label: "Hardware Maintenance Team" },
    { value: "hr_team", label: "HR Support Team" },
    { value: "logistics_team", label: "Logistics and Dispatch Team" },
    { value: "admin_team", label: "Admin & Facility Team" },
  ];
  const locationOptions = [
    { value: "central_inventory", label: "Central Inventory" },
    { value: "hardware_store", label: "Hardware Store" },
    { value: "software_warehouse", label: "Software Warehouse" },
    { value: "it_lab", label: "IT Lab Inventory" },
    { value: "regional_storage", label: "Regional Storage Facility" },
  ];
  useEffect(() => {
    if (isViewMode || isEditMode) {
      Object.entries(dummyData).forEach(([key, value]) => {
        setValue(key, value);
      });
    }
  }, [isViewMode, isEditMode, setValue]);

  const customStyles = {
    control: (provided) => ({
      ...provided,
      borderRadius: "8px",
      borderColor: "#D9D9D9",
      minHeight: "40px",
      fontSize: "14px",
    }),
  };

const onSubmit = (data) => {
  const payload = {
    chooseteam: data.regionname?.value || "",
    inventorydepart: data.location?.value || "",
  };

  navigate("/technical-view");
};


  return (
    <div>
      <Topbar header="Pending" subHead="Edit / Move" />

      <div className="container_fluit1 px-4 py-3">
        <label className="f2 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-19 fs-xxl-20 mb-3 mt-3">
          Regional Ticket ID :{" "}
          <span className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-19 fs-xxl-20">
            N3465
          </span>
        </label>

        <form
          className="d-flex flex-wrap gap-5"
          onSubmit={handleSubmit(onSubmit)}
        >
          {/* Region Select */}
          <div className="col-md-5">
            <Controller
              control={control}
              name="regionname"
              rules={{ required: "Region is required" }}
              render={({ field }) => (
                <div>
                  <label className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 mb-1">
                    Choose the Team
                  </label>
                  <Select
                    {...field}
                    options={regionOptions}
                    placeholder="Select Region"
                    isSearchable
                    onChange={field.onChange}
                    value={field.value}
                    styles={customStyles}
                    isDisabled={isViewMode}
                  />
                  {errors.regionname && (
                    <p style={{ color: "red" }}>{errors.regionname.message}</p>
                  )}
                </div>
              )}
            />
          </div>

          {/* Location Select */}
          <div className="col-md-5">
            <Controller
              control={control}
              name="location"
              rules={{ required: "Location is required" }}
              render={({ field }) => (
                <div>
                  <label className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 mb-1">
                    Inventory Department
                  </label>
                  <Select
                    {...field}
                    options={locationOptions}
                    placeholder="Select Location"
                    isSearchable
                    onChange={field.onChange}
                    value={field.value}
                    styles={customStyles}
                    isDisabled={isViewMode}
                  />
                  {errors.location && (
                    <p style={{ color: "red" }}>{errors.location.message}</p>
                  )}
                </div>
              )}
            />
          </div>

            <div className="col-md-11 mt-3">
                                  <Controller
                                      control={control}
                                      name="issue"
                                      rules={{ required: "Role is required" }}
                                      render={({ field }) => (
                                          <div>
                                              <label className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 mb-1">
                                                  Issue Description By Super Admin <span style={{ color: "red" }}>*</span>
                                              </label>
                                              <input
                                                  {...field}
                                                  className="input-box"
                                                  placeholder="Enter Role"
                                                  disabled={isViewMode}
                                              />
                                              {errors.issue && (
                                                  <p style={{ color: "red" }}>{errors.issue.message}</p>
                                              )}
                                          </div>
                                      )}
                                  />
                              </div >
        </form>

        {/* Buttons */}
        <div className="d-flex col-md-11 button_submit ac-jb my-3">
          <button
            type="button"
            onClick={() => navigate(-1)}
            className="back_btn f2 fs-sm-15 fs-md-15 fs-lg-17 fs-xl-18 fs-xxl-20"
          >
            Back
          </button>

          <button
            type="submit"
             onClick={() => setPopup(true)}
            className="Add_btn f2 fs-sm-15 fs-md-15 fs-lg-17 fs-xl-18 fs-xxl-20"
          >
            Assign
          </button>
        </div>
                {popup && (
                <div className="img-popup-design">
                  <div className="img-popup">
                    <p className="f3 mt-4 mb-2 f2 fs-xs-14 fs-sm-11 fs-md-13 fs-lg-15 fs-xl-17 fs-xxl-19 ">
                      Are you sure you want to assign?
                    </p>
                    <div className="d-flex ac-jb px-2 mt-5">
                      <button
                        onClick={() => setPopup(false)}
                        className="no-btn f2 w-40"
                      >
                        No
                      </button>
                      <button  onClick={() => navigate("/technical-view")} className="yes-btn f2 w-40">
                       Yes
                      </button>
                    </div>
                  </div>
                </div>
              )}


       
      </div>
    </div>
  );
};

export default TechnicalMove;
